import React from 'react';

const Upload = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "17",
    height: "16",
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.16797 11.3332V12.6665C3.16797 13.0201 3.30844 13.3593 3.55849 13.6093C3.80854 13.8594 4.14768 13.9998 4.5013 13.9998H12.5013C12.8549 13.9998 13.1941 13.8594 13.4441 13.6093C13.6942 13.3593 13.8346 13.0201 13.8346 12.6665V11.3332M5.16797 5.99984L8.5013 2.6665M8.5013 2.6665L11.8346 5.99984M8.5013 2.6665V10.6665",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
Upload.displayName = "Icons.Upload";

export { Upload };
//# sourceMappingURL=Upload.js.map
